// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UB_ce","option":"styles_option__28bsO","selected":"styles_selected__3M7Cq"};